module.exports = __webpack_public_path__ + "static/media/floorM.41ff8e85.png";